import React from 'react';
import { Button } from '@mui/material';

const OutlinedIconButton = ({ onClick, color = 'primary', children }) => {
  return (
    <Button
      variant="contained"
      color={color}
      sx={{ aspectRatio: 1, padding: 0.5, minWidth: 0, boxShadow: 0 }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default OutlinedIconButton;
